/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountToJSONTyped,
} from './Account';

/**
 * 
 * @export
 * @interface GetAccountOutputBody
 */
export interface GetAccountOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof GetAccountOutputBody
     */
    readonly $schema?: string;
    /**
     * Account
     * @type {Account}
     * @memberof GetAccountOutputBody
     */
    account: Account;
}

/**
 * Check if a given object implements the GetAccountOutputBody interface.
 */
export function instanceOfGetAccountOutputBody(value: object): value is GetAccountOutputBody {
    if (!('account' in value) || value['account'] === undefined) return false;
    return true;
}

export function GetAccountOutputBodyFromJSON(json: any): GetAccountOutputBody {
    return GetAccountOutputBodyFromJSONTyped(json, false);
}

export function GetAccountOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'account': AccountFromJSON(json['account']),
    };
}

export function GetAccountOutputBodyToJSON(json: any): GetAccountOutputBody {
    return GetAccountOutputBodyToJSONTyped(json, false);
}

export function GetAccountOutputBodyToJSONTyped(value?: Omit<GetAccountOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': AccountToJSON(value['account']),
    };
}

